/* eslint-disable max-lines-per-function */
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { Datum } from '@/domain/navigation/benachrichtigungen/components/details/shared/Datum';
import { DetailWrapper } from '@/domain/navigation/benachrichtigungen/components/details/shared/DetailWrapper';
import { useUpdateFristGelesen } from '@/domain/navigation/benachrichtigungen/hooks/useUpdateFristGelesen';
import { Fristen } from '@/domain/navigation/benachrichtigungen/types/Fristen';
import { toast } from '@/hooks/use-toast';
import { managerV1BaseUrl } from '@/utils';
import { faXmarkLarge } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export default function FristenDetail({
  benachrichtigung,
}: {
  benachrichtigung: Fristen;
}) {
  const { t } = useTranslation();
  const [update] = useUpdateFristGelesen();

  function handleUpdate() {
    update({
      input: {
        id: benachrichtigung.id,
        istGelesen: true,
      },
    })
      .then(() =>
        toast({
          title: t('domain.navigation.benachrichtigungen.fristUpdate.success'),
        }),
      )
      .catch(() =>
        toast({
          title: t('domain.navigation.benachrichtigungen.fristUpdate.error'),
        }),
      );
  }

  const linkTo = `${managerV1BaseUrl}/secure/v2/in/search.jsf?idMitarbeiter=${benachrichtigung.mitarbeiter.id}&detailPage=fristen`;

  return (
    <a href={linkTo}>
      <DetailWrapper
        mitarbeiter={benachrichtigung.mitarbeiter}
        content={
          <div className="w-fit h-5 px-2 py-1 bg-neutrals-300 rounded-full inline-flex justify-center items-center gap-1">
            <div className="text-center justify-start text-neutrals-900 text-xs font-semibold  leading-none">
              {benachrichtigung.grund}
            </div>
          </div>
        }
        footer={<Datum von={benachrichtigung.ablaufZeitpunkt} />}
        rightSide={
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <button
                  className="w-6 h-6 rounded-md p-1 hover:bg-neutrals-300 flex justify-center items-center"
                  onClick={(e) => {
                    e.preventDefault();
                    handleUpdate();
                  }}>
                  <FontAwesomeIcon
                    icon={faXmarkLarge}
                    className="max-h-3 max-w-3 text-primary-blue-600"
                  />
                </button>
              </TooltipTrigger>
              <TooltipContent align="end" side="bottom">
                {t('domain.navigation.benachrichtigungen.fristEntfernen')}
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        }
      />
    </a>
  );
}
